import { render, staticRenderFns } from "./MyQuizzesSetModal.vue?vue&type=template&id=2cdf5674&scoped=true&"
import script from "./MyQuizzesSetModal.vue?vue&type=script&lang=js&"
export * from "./MyQuizzesSetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdf5674",
  null
  
)

export default component.exports